<template>

<div class="main-content">
  <div class="terms">
    <center><h1>Terms & Conditions</h1></center>
    <br>

    <p>March 30, 2025</p>

    <p>
        Welcome to <strong>Market Price Tracker</strong>, a price tracking service designed to help users monitor and 
        compare the prices of market goods. By using the App, you agree to comply with and be bound by the following 
        Terms and Conditions. Please read them carefully before proceeding.
    </p>

    <br>
    <strong><h2>1. Acceptance of Terms</h2></strong>
    <p>
        By accessing or using the App, you acknowledge that you have read, understood, and agreed to these Terms and 
        Conditions, along with our Privacy Policy. If you do not agree, you must discontinue use of the App immediately.
    </p>
    
    <br>
    <strong><h2>2. Service Description</h2></strong>

    <p>
        The App provides users with price tracking services for various market goods, 
        including common consumer products, produce and meat. The App gathers pricing data 
        from multiple sources and displays trends, old data, and uses charts to visualize prices.
    </p>

    <br>
    <strong><h2>3. Disclaimer of Accuracy</h2></strong>

    <p>
        While we strive to provide accurate and up-to-date pricing information, we do not guarantee the completeness, 
        reliability, or accuracy of the data. Prices may vary due to factors such as:
    </p>

    <ul>
        <li>Real-time market fluctuations</li>
        <li>Errors in data collection</li>
        <li>Changes by retailers without notice</li>
        <li>Regional or store-specific pricing differences</li>
    </ul>
    
    <p>
        <strong>The App should not be solely relied upon for financial or purchasing decisions.</strong>
        Always verify prices directly with the retailer before making a purchase.
    </p>
    
    <br>
    <strong><h2>4. Admin Responsibilities & Misuse Policy</h2></strong>

    <p>
        Administrators with access to price modification features must adhere to the following:
    </p>

    <ul>
        <li> <strong> Accurate Updates Only:</strong> Admins must ensure that price changes reflect real, verified market data.</li>
        <li> <strong> No Manipulation:</strong> Deliberately falsifying, inflating, or tampering with prices for any reason is strictly prohibited.</li>
        <li> <strong> No Unauthorized Changes:</strong> Admins must not alter prices without proper justification or verification.</li>
    </ul> 
   
    <p>
        <strong>Violation of these rules will result in:</strong>
    </p>

    <ul>
        <li>Immediate suspension of admin privileges.</li>
        <li>Investigation and potential permanent removal from the system.</li>
        <li>Legal action if fraudulent activity is detected.</li>
    </ul> 

    <br>
    <strong><h2>5. User Responsibilities</h2></strong>

    <p>
        You agree to:
    </p>

    <ul>
        <li>Use the App only for lawful purposes.</li>
        <li>Not misuse the App to harass, scam, or deceive others.</li>
        <li>Not attempt to manipulate or interfere with the App's functionality.</li>
        <li>Acknowledge that the App is a supplementary tool and not a substitute for personal judgment.</li>
    </ul> 
 
    <br>
    <strong><h2>6. Limitation of Liability</h2></strong>

    <p>
        To the fullest extent permitted by law we shall not be liable for any:
    </p>

    <ul>
        <li>Inaccurate, outdated, or missing price information.</li>
        <li>Financial losses or damages resulting from reliance on the App.</li>
        <li>Technical issues, including app downtime or data errors.</li>
        <li>Third-party actions or retailer pricing changes.</li>
        <li>Misconduct by administrators or unauthorized price alterations.</li>
        <li>Milk</li>
    </ul> 

    <br>
    <strong><h2>7. Changes to Terms & Service</h2></strong>

    <p>
        We reserve the right to modify these Terms at any time. 
        Continued use of the App after changes constitutes acceptance of the updated Terms.
    </p>

    <br>
    <strong><h2>8. Termination</h2></strong>

    <p>
        We may suspend or terminate your access to the App at any time for violations of these Terms or for any other 
        reason without notice.
    </p>

    <br>
    <strong><h2>9. Governing Law</h2></strong>

    <p>
        These Terms shall be governed by and construed in accordance with the laws of Olongapo City.
    </p>

    <br>
    <strong><h2>10. Contact Information</h2></strong>

    <p>
        For questions or concerns regarding these Terms, please contact us at:
        Rusiann7@protonmail.com 
        By using Market Price Tracker, you agree to these Terms and Conditions. Thank you for using our service!
    </p>
  </div>
</div>
</template>
<script>

export default {
    name: 'endUser',
}

</script>

<style>
.h1,div,p,ul,li,h2{
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.terms{
 max-width: 1100px;
 padding-top: 50px;
  margin: auto;
  color: #000000;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 30px;
  text-align: left;
  font-size: 1rem;
}

.main-content {
  padding-top: 0;
  margin-top: 100px;
  margin-bottom: 100px;
  align-items: left;
  justify-content: left;
  display: flex;
  min-height: calc(100vh - 50px);
}

.h1 {
    text-align: center;
}

.p {
  font-size: 2rem;

}
</style>